import { buildApiUrl } from '../helpers/buildApiUrl';
import httpService from './httpService';
const list = async (type, data = {}) => {
    return httpService.get(buildApiUrl(`/reports/${type}`), data);
};
export default {
    list,
};
